module.exports = "/out/1c28f7a032971ca0e0e910323c1bea8e.svg";